.footer {
  margin-top: auto;
  background: var(--color-bg-deep);
  border-top: 1px solid var(--color-border);
  padding: var(--space-12) 0 var(--space-6);
}

.container {
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 0 var(--container-padding);
}

.grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-8);
  margin-bottom: var(--space-10);
}

@media (min-width: 640px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .grid {
    grid-template-columns: 2fr repeat(3, 1fr);
  }
}

/* Brand */
.brand {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.logo {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  text-decoration: none;
}

.logoIcon {
  width: 48px;
  height: 48px;
  flex-shrink: 0;
}

.potatoIcon {
  width: 100%;
  height: 100%;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,0.5));
}

.logoText {
  display: flex;
  flex-direction: column;
  line-height: 1;
}

.logoMain {
  font-family: var(--font-heading);
  font-size: 28px;
  font-weight: 400;
  color: var(--color-text);
  letter-spacing: -0.02em;
  text-shadow: 0 2px 4px rgba(0,0,0,0.5);
}

.logoSub {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  color: var(--color-primary);
  margin-top: -4px;
  text-shadow: 0 1px 2px rgba(0,0,0,0.5);
}

.tagline {
  font-family: var(--font-body);
  font-size: 14px;
  color: var(--color-text-dim);
  line-height: 1.6;
  max-width: 280px;
}

.social {
  display: flex;
  gap: var(--space-3);
  margin-top: var(--space-2);
}

.socialLink {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  color: var(--color-text-muted);
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  transition: all var(--transition-fast);
}

.socialLink:hover {
  color: var(--color-primary);
  border-color: var(--color-primary);
  background: var(--color-bg-panel-hover);
  transform: translateY(-2px);
}

.socialLink:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

.socialIcon {
  width: 20px;
  height: 20px;
}

/* Navigation Sections */
.navSection {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.sectionTitle {
  font-family: var(--font-heading);
  font-size: 16px;
  font-weight: 400;
  color: var(--color-text);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 2px solid var(--color-primary);
  padding-bottom: var(--space-2);
  display: inline-block;
}

.linkList {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.link {
  font-family: var(--font-body);
  font-size: 13px;
  color: var(--color-text-dim);
  text-decoration: none;
  transition: color var(--transition-fast);
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
}

.link:hover {
  color: var(--color-primary);
}

.link:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
  border-radius: var(--radius-sm);
}

.externalIcon {
  width: 12px;
  height: 12px;
  opacity: 0.6;
  flex-shrink: 0;
}

.link:hover .externalIcon {
  opacity: 1;
}

/* Server Info */
.serverInfo {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.serverStatus {
  display: flex;
  align-items: center;
}

.version {
  display: flex;
  align-items: baseline;
  gap: var(--space-2);
  padding-top: var(--space-2);
  border-top: 1px solid var(--color-border-dim);
}

.versionLabel {
  font-family: var(--font-body);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-muted);
}

.versionValue {
  font-family: var(--font-mono);
  font-size: 13px;
  font-weight: 700;
  color: var(--color-text);
}

/* Bottom Bar */
.bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-4);
  padding-top: var(--space-6);
  border-top: 1px solid var(--color-border-dim);
}

@media (min-width: 640px) {
  .bottom {
    flex-direction: row;
    justify-content: space-between;
  }
}

.copyright {
  font-family: var(--font-body);
  font-size: 12px;
  color: var(--color-text-muted);
  text-align: center;
}

@media (min-width: 640px) {
  .copyright {
    text-align: left;
  }
}

.legalLinks {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--space-4);
}

@media (min-width: 640px) {
  .legalLinks {
    justify-content: flex-end;
  }
}

.legalLink {
  font-family: var(--font-body);
  font-size: 12px;
  color: var(--color-text-muted);
  text-decoration: none;
  transition: color var(--transition-fast);
}

.legalLink:hover {
  color: var(--color-primary);
}

.legalLink:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
  border-radius: var(--radius-sm);
}